import { AvailableCertificates } from 'types/certificates';
import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import i18next from 'i18next';

export class CertificateService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  certificateLevel = async (level: string) => {
    const response = await this.axiosInstance.get(`/api/certificate-pdf/${level}`, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
    });

    if (response.data) {
      if (response.status === 400) {
        return {
          status: 'error',
          data: JSON.parse(await response.data.text()),
        };
      } else if (response.status === 200 && response.data.type === 'application/pdf') {
        return { status: 'success', data: response.data };
      }
    }
    throw Error(i18next.t('DownloadCertificateError', { level: level, ns: 'certificate' }));
  };

  checkAvailableCertificates = async () => {
    const response = await this.axiosInstance.get<Result<AvailableCertificates>>('/api/certificate-pdf/check-available-certificates');

    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }

    throw Error(i18next.t('CheckAvailableCertificatesError', { ns: 'certificate' }));
  };
}

export default CertificateService;
